import { useRequiredContext } from "@redotech/react-util/context";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { returnsSettingsParentPath } from "@redotech/redo-merchant-app-common/settings/returns-settings-parent-path";
import { useReturnsSettingsExperience } from "@redotech/redo-merchant-app-common/settings/use-returns-settings-experience";
import { useSettingsVisibility } from "@redotech/redo-merchant-app-common/settings/use-settings-visibility";
import type { SettingsPageId } from "@redotech/redo-settings-common/settings-visibility/settings-pages";
import { memo } from "react";
import { Navigate, Outlet } from "react-router-dom";

/**
 * Route layout for an old returns settings page itself, not its sub-pages: the
 * new page links into those. Once settings visibility hides the page, bookmarks
 * and old links land on the tab that replaced it.
 */
export const LegacyReturnsSettingsRedirect = memo(
  function LegacyReturnsSettingsRedirect({
    legacyPath,
    page,
  }: {
    legacyPath: string;
    page: SettingsPageId;
  }) {
    const routes = useRequiredContext(MerchantRoutesContext);
    const { pending, useNewUi } = useReturnsSettingsExperience();
    const visibility = useSettingsVisibility();
    if (pending) {
      return null;
    }
    if (useNewUi && !visibility.page(page)) {
      return (
        <Navigate
          replace
          to={routes.getSettingsSubRoute(
            returnsSettingsParentPath(legacyPath, true),
          )}
        />
      );
    }
    return <Outlet />;
  },
);
